<template>
  <div>
  <div id="page" data-swup="0" class="device-is-android">
    <header-bar style="overflow:hidden"></header-bar>
    <footer-bar></footer-bar>
    <div
      class="page-content header-clear-medium has-footer-menu"
      style="transform: translateX(0px)"
    >
      <a
        v-for="task in tasks"
        :key="task.id"
        @click="handleDetailModal({ show: true, id: task.id })"
        data-menu="menu-modal-view"
        class="card card-style bg-1"
        data-card-height="220"
        style="height: 220px"
        :style="`background-image:url('${task.defaultAttachmentUrl}?w=820&h=220&mode=pad')`"
      >
        <div class="card-bottom p-3">
          <h1 class="color-white font-20" style="text-shadow: rgba(0, 0, 0, 2) 2px 2px 10px;">{{ getLangText(task) }}</h1>          
        </div>
        <div class="card-overlay bg-gradient"></div>
      </a>
    </div>
    <div class="page-bg">
      <div></div>
    </div>
    <div class="divider divider-margins"></div>
  </div>
</div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";
export default {
  components: {
    footerBar,
    headerBar,
  },
  data() {
    return {
      title:"",
      tasks: {},
    };
  },
  methods: {
    ...mapActions(["handleDetailModal"]),
    getLangText(task) {
      let lng = this.$i18n.locale;
      if (lng == "en") {
        return task.st5 ?? task.task;
      } else if (lng == "ru") {
        return task.st4 ?? task.task;
      } else if (lng == "cn") {
        return task.st6 ?? task.task;
      } else {
        return task.task;
      }
    },
    init() {
      request({
        api: { method: "POST", url: "taskCore/getCoreList" },
        data: {
          skip: 0,
          size: 10,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: this.$route.params.id,
          },
        },
        store: this.$store,
      }).then((res) => {
        this.tasks = _.sortBy(res.data.tasks, "ord", "asc");
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        this.init();
      }
    },
  },
};
</script>
